// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mgl5[data-v-4208991c] {\n  margin-left: 5px;\n}\n.mgl10[data-v-4208991c] {\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
